import { render } from "./regular-physical-examination.vue?vue&type=template&id=1b38de8c&scoped=true&ts=true"
import script from "./regular-physical-examination.vue?vue&type=script&lang=ts"
export * from "./regular-physical-examination.vue?vue&type=script&lang=ts"

import "./regular-physical-examination.vue?vue&type=style&index=0&id=1b38de8c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38de8c"]])

export default __exports__